/**
 * We have table country_codes where we have column id
 * @type {Readonly<{GERMANY: number}>}
 */
export const CountryDialCodeIdEnum = Object.freeze({
    GERMANY: 25,
});
